<template>
  <b-container fluid class="header" v-if="help">
    <b-jumbotron fluid>
      <h2 class='text-white'>Content</h2>
      <p class='text-white'>Automate your content creation</p>
      <b-button @click='help = !help'>Get started</b-button>
    </b-jumbotron>

    <b-container class="mt-4">
      <b-card title="Content creation" class="mb-4">
        High quality and fresh content is the bedrock of SEO. Have content automatically created for you each month.
      </b-card>
    </b-container>
  </b-container>

  <b-container fluid v-else>
    <div class="horizontal-menu">
      <b-row>
        <b-col>
          <h2>Content</h2>
        </b-col>
        <b-col class="float-right">
          <b-button class="float-right" variant="transparent" @click="help = !help"><i class="far fa-question-circle"></i></b-button>
        </b-col>
      </b-row>
      <b-nav>
        <b-nav-item :to="{name: 'content_auto'}" exact exact-active-class="tab_active">Automatic</b-nav-item>
        <!-- <b-nav-item :to="{name: 'keywords'}" exact exact-active-class="tab_active">Keywords</b-nav-item>
        <b-nav-item :to="{name: 'content_copy'}" exact exact-active-class="tab_active">Copy</b-nav-item> -->
      </b-nav>
    </div>

    <router-view :profile="profile" :user="user" :site="site" />
  </b-container>
</template>

<script>

import { db } from '@/main.js'

export default {
  name: 'site_content',
  props: ['profile', 'user', 'site'],
  data() {
    return {
      help: this.site.help.content
    }
  },
  watch: {
    help(val) {
      if (this.site.help.content && !val) {
        db.collection('site').doc(this.site.id).update({'help.content': false})
      }
    }
  }
}
</script>

<style scoped>

</style>
